import { AppParams } from '../../types';
import { ExperimentsBag } from '@wix/wix-experiments';

export const initWixRecorder = (
  appParams: AppParams,
  experiments: ExperimentsBag,
): void => {
  const wixRecorder: WixRecorder = (window as any).wixRecorder;
  if (wixRecorder) {
    wixRecorder.addLabel('premium-purchase-plan');
    wixRecorder.withExperiments(experiments);
    Object.entries(appParams).forEach(([key, value]) => {
      if (typeof value === 'string') {
        wixRecorder.addCustomAttribute(key, value);
      }
    });
  }
};
